module.exports = __webpack_public_path__ + "static/media/call20.6b4aa03f.png";